import {cloneDeep} from 'lodash';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {Store} from '@ngxs/store';
import {Loader} from '../../models/loader/loader.redux';
import {ClinicState} from '../../models/clinic';
import {PlanActions, PlanState} from '../../models/plan';
import {firstValueFrom, Observable} from 'rxjs';
import {BillingInfoDTO, SubscriptionDTO} from '../../dtos/billing';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {Logger} from '../../class/helper/logger.class';

@Component({
  selector: 'app-modal-cancel-plan',
  templateUrl: './modal-cancel-plan.component.html',
  styleUrls: ['./modal-cancel-plan.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalCancelPlanComponent implements OnInit {
  // tslint:disable:no-redundant-jsdoc
  @Input() clinicId: string;
  @Input() isVisibleModal: boolean;
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  billingInfo$: Observable<BillingInfoDTO> = this.store.select<BillingInfoDTO>(PlanState.getBillingInfo);
  subscriptionActive$: Observable<SubscriptionDTO> = this.store.select<SubscriptionDTO>(PlanState.getSubscriptionActive);
  optionCancel: boolean;
  moreDays: boolean;
  moreDaysAccept: boolean;
  reasonCancel: boolean;
  reason: string;
  constructor(
    private store: Store,
    private alertService: MessageAlertService
  ) { }

  ngOnInit(): void {
    this.optionCancel = true;
  }

  /**
   * Se verifica si el usuariio es acreedor a 15 días extra fratis de plan p sino pasa
   * al siguiente modal de eliminación.
   */
  async onSelectCancelPlan(): Promise<void> {
    // se verifica si el usuario es acreedor a 15 días extra gratis o si no se pasa al sigueinte modal
    const clinic = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicState.getClinicSelected))));
    this.optionCancel = false;
    if (clinic && !clinic.metadata?.cancellationPromo) {
      // es la primera vez que aplica a la promocion
      this.reasonCancel = false;
      this.moreDays = true;
    } else {
      // anteriormente ya habia aplicado a la promocion
      this.moreDays = false;
      this.reasonCancel = true;
    }
  }

  /**
   * Se aceptan los 15 días extras gratis.
   * @param value
   */
  async onSelectAcceptMoreDays(value: boolean): Promise<void> {
    if (!value) {
      // no se aceptan los 15 días extra
      this.moreDays = false;
      this.moreDaysAccept = false;
      this.reasonCancel = true;
      return;
    }
    await firstValueFrom((this.store.dispatch(new Loader(true))));
    this.moreDaysAccept = value;
    // se aceptan los 15 días extra
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Aplicando la promoción'))));
      await firstValueFrom((this.store.dispatch(new PlanActions.AddFreeDays(this.clinicId))));
      this.moreDays = false;
      this.moreDaysAccept = true;
      this.reasonCancel = true;
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
      this.alertService.createMessage('error', 'Hubo un error al aplicar la promoción');
    }
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  /**
   * Se cierra el modal
   */
  onClose(): void {
    this.closed.emit(true);
    setTimeout(() => {
      this.optionCancel = true;
      this.moreDays = false;
      this.moreDaysAccept = false;
      this.reasonCancel = false;
      this.reason = '';
    }, 100);
  }

  /**
   * Se cancela la suscripción.
   */
  async onCancelSubscription(): Promise<void> {
    try {
      await firstValueFrom((this.store.dispatch(new Loader(true, 'Cancelando suscripción ...'))));
      await firstValueFrom((this.store.dispatch(new PlanActions.Cancel(this.clinicId))));
      this.onClose();
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
      this.alertService.createMessage('error', 'Hubo un error al cancelar la suscripción, intente más tarde.');
    }
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }
}
